module.exports = __webpack_public_path__ + "img/essay.9e6c5c4e.svg";